export default function DocumentsSection() {
  const documents = [
    {
      title: 'ご契約者さまの印鑑証明書',
      icon: 'ri-shield-check-line',
      color: 'from-teal-500 to-cyan-500'
    },
    {
      title: 'ご契約者様のご身分証コピー',
      icon: 'ri-id-card-line',
      color: 'from-cyan-500 to-blue-500'
    },
    {
      title: '上記以外の代表者、取引担当者がいる場合はそのご身分証コピー',
      icon: 'ri-team-line',
      color: 'from-blue-500 to-indigo-500'
    }
  ];

  return (
    <section className="py-32 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-20">
          <div className="inline-flex items-center px-6 py-3 bg-indigo-50 rounded-full mb-6">
            <i className="ri-file-list-3-line text-indigo-600 text-xl mr-3"></i>
            <span className="text-indigo-600 text-sm font-bold">DOCUMENTS</span>
          </div>
          <h2 className="text-5xl font-black text-gray-900 mb-6">
            必要書類・<span className="bg-gradient-to-r from-teal-500 to-cyan-500 bg-clip-text text-transparent">物品</span>
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-16">
          {documents.map((doc, index) => (
            <div
              key={index}
              className="group relative bg-gradient-to-br from-gray-50 to-white rounded-3xl p-8 hover:shadow-2xl transition-all duration-500 border border-gray-200 hover:border-teal-300"
            >
              <div className={`w-16 h-16 bg-gradient-to-br ${doc.color} rounded-2xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-500`}>
                <i className={`${doc.icon} text-3xl text-white`}></i>
              </div>
              <h3 className="text-lg font-black text-gray-900 leading-tight">
                {doc.title}
              </h3>
            </div>
          ))}
        </div>

        {/* Additional Note */}
        <div className="bg-gradient-to-br from-blue-50 to-indigo-50 rounded-3xl p-10 border border-blue-200">
          <div className="flex items-start">
            <div className="w-12 h-12 bg-gradient-to-br from-blue-500 to-indigo-500 rounded-xl flex items-center justify-center mr-6 flex-shrink-0">
              <i className="ri-alert-line text-2xl text-white"></i>
            </div>
            <div>
              <h4 className="text-2xl font-black text-gray-900 mb-4">ご注意</h4>
              <p className="text-gray-700 leading-relaxed mb-4">
                加えて状況に応じて、購入者様の現在のお仕事内容や、事業実態の確認をさせて頂く場合がございます。
              </p>
              <p className="text-gray-700 leading-relaxed">
                詳しくは下記もご確認ください
              </p>
              <a
                href="#"
                className="inline-flex items-center mt-4 text-blue-600 font-bold hover:text-blue-700 transition-colors cursor-pointer"
              >
                弊社のM&Aコンプライアンス（身分確認等の実施）
                <i className="ri-arrow-right-line ml-2"></i>
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
